import React, { useState, useEffect } from "react";
import { Container, Button, Row, Col, Modal, Spinner, Alert, Form } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import "../styles/LatestUpdatesPage.css";
import { MoveUpRight, X } from "lucide-react";
import { MdOutlineTipsAndUpdates } from "react-icons/md";

const LatestUpdatesPage = () => {
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [latestUpdates, setLatestUpdates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openPdf, setOpenPdf] = useState(false);
    const [openImage, setOpenImage] = useState(false);
const [showFullDescription, setShowFullDescription] = useState({});
    // Fetch updates from API
    useEffect(() => {
        const fetchUpdates = async () => {
            try {
                setLoading(true);
                const response = await fetch(`${process.env.REACT_APP_BASEURL}/getAllUpdatescms`);
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const result = await response.json();
                
                // Check if the response has the expected structure
                if (result.success && result.data) {
                    // Filter out deleted items and only include active ones
                    const activeUpdates = result.data.filter(update => 
                        update.status === 1
                    );
                    
                    setLatestUpdates(activeUpdates);
                } else {
                    throw new Error('Invalid response format');
                }
            } catch (err) {
                console.error('Error fetching updates:', err);
                setError('Failed to load updates. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchUpdates();
    }, []);

    useEffect(() => {
        setOpenPdf(false);
        setOpenImage(false);
    }, [selectedPdf]);

    const handleUpdateClick = (update) => {
        if (update.pdf || update.image) {
            setSelectedPdf(update);
            setShowPdfModal(true);
        }
    };

    // Close PDF modal
    const handleClosePdfModal = () => {
        setShowPdfModal(false);
        setSelectedPdf(null);
    };

    // Loading state
    if (loading) {
        return (
            <>
                {/* Hero Section */}
                <section
                    className="hero-fixed-latest-updates"
                    style={{ backgroundImage: `url(${heroBg})` }}
                >
                    <div className="hero-content-latest-updates">
                        <h1 className="hero-title">All India Occupational Therapists' Association</h1>
                    </div>
                </section>

                {/* Loading Content */}
                <div className="scrollable-content scrollable-content-latest-updates">
                    <div className="content-container latest-updates-content-container">
                        <Container className="container-latest-updates">
                            <div className="text-center py-5">
                                <Spinner animation="border" role="status" className="mb-3">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p>Loading latest updates...</p>
                            </div>
                        </Container>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            {/* Fixed Hero Section */}
            <section
                className="hero-fixed"
                style={{ backgroundImage: `url(${heroBg})` }}
            >
                <div className="hero-scroll-content">
                    <div className="hero-content-home poppins-regular">
                        <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
                    </div>
                </div>
            </section>

            {/* Scrollable Content Container */}
            <div className="scrollable-content-home">
                <div className="content-container latest-updates-content-container">
                    <section className="latest-updates-section">
                        <Container className="container-latest-updates">
                            <h2 className="text-center latest-updates-heading mb-4">
                                Latest Updates
                            </h2>

                            {/* Error handling */}
                            {error && (
                                <Alert variant="danger" className="text-center">
                                    {error}
                                </Alert>
                            )}

                            {/* No updates message */}
                            {!error && latestUpdates.length === 0 && (
                                <Alert variant="info" className="text-center">
                                    No updates available at the moment.
                                </Alert>
                            )}

                            {/* Updates Grid */}
{/* Updates Grid */}
{/* Updates Grid */}
{!error && latestUpdates.length > 0 && (
    <Row className="g-3 d-flex">
        {latestUpdates.map((update) => {
            const isDescriptionLong = update.description.length > 50;
            const displayDescription = showFullDescription[update._id] ? update.description : update.description.slice(0, 50) + (isDescriptionLong && !showFullDescription[update._id] ? "..." : "");

            return (
                <Col xs={12} sm={6} md={4} lg={6} key={update._id}>
                    <Button
                        className="latest-updates-btn w-100 h-100 p-3 d-flex justify-content-center align-items-center gap-3"
                        style={{ height: '250px', overflow: 'hidden' }}
                    >
                        <div className="d-flex flex-column align-items-center gap-2 w-100">
                            {/* Title with larger font size - WHITE COLOR */}
                            <span 
                                className="latest-updates-title" 
                                style={{
                                    fontSize: '30px', // Increased font size
                                    fontWeight: '700', // Bolder
                                    color: '#ffffff', // WHITE COLOR
                                    marginBottom: '10px',
                                    textAlign: 'center'
                                }}
                            >
                                {update.title}
                            </span>
                            
                            {/* Description with smaller font size - WHITE COLOR */}
                            <span 
                                className="latest-updates-description" 
                                style={{ 
                                    overflow: 'hidden', 
                                    textOverflow: 'ellipsis', 
                                    whiteSpace: 'normal',
                                    fontSize: '14px', // Slightly smaller than title
                                    color: '#ffffff', // WHITE COLOR
                                    lineHeight: '1.5',
                                    textAlign: 'center',
                                    marginBottom: '15px'
                                }}
                            >
                                {displayDescription}
                                {isDescriptionLong && (
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowFullDescription(prev => ({
                                                ...prev,
                                                [update._id]: !prev[update._id]
                                            }));
                                        }}
                                        style={{
                                            color: '#ffffff', // WHITE COLOR
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            padding: '0 5px',
                                            cursor: 'pointer',
                                            marginLeft: '5px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        {showFullDescription[update._id] ? 'Read Less' : 'Read More'}
                                    </button>
                                )}
                            </span>
                            
                            {/* Buttons section */}
                            <div className="d-flex w-100" style={{ justifyContent: (update.link && (update.pdf || update.image)) ? 'space-between' : 'center', gap: '10px' }}>
                                {update.link && (
                                    <Button
                                        variant="outline-primary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            window.open(update.link, "_blank");
                                        }}
                                        className="mt-2"
                                        style={{ 
                                            backgroundColor: '#0030B6', 
                                            color: '#ffffff', 
                                            border: '2px solid #ffffff'
                                        }}
                                    >
                                        Visit Link
                                    </Button>
                                )}
                                {(update.pdf || update.image) && (
                                    <Button
                                        variant="outline-primary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUpdateClick(update);
                                        }}
                                        className="mt-2"
                                        style={{ 
                                            backgroundColor: '#0030B6', 
                                            color: '#ffffff', 
                                            border: '2px solid #ffffff'
                                        }}
                                    >
                                        Explore More
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Button>
                </Col>
            );
        })}
    </Row>
)}
                        </Container>
                    </section>
                </div>
            </div>

            {/* PDF Viewer Modal */}
            <Modal 
                show={showPdfModal} 
                onHide={handleClosePdfModal} 
                size="xl" 
                centered
                className="pdf-viewer-modal"
            >
                <Modal.Header className="d-flex justify-content-between align-items-center">
                    <Modal.Title>{selectedPdf?.title || "PDF Viewer"}</Modal.Title>
                    <Button 
                        variant="outline-secondary" 
                        onClick={handleClosePdfModal}
                        className="close-btn"
                    >
                        <X size={24} />
                    </Button>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {selectedPdf && (
                        <div className="pdf-viewer-container">
                            {/* Show image if available */}
                            {selectedPdf.image && (
                                <div className="text-center p-3">
                                    <img
                                        src={selectedPdf.image}
                                        alt={selectedPdf.title}
                                        className="img-fluid rounded mb-3"
                                        style={{ maxHeight: "400px", objectFit: "contain" }}
                                    />
                                </div>
                            )}

                            {/* Show PDF if available */}
                            {selectedPdf.pdf && (
                                <iframe
                                    src={selectedPdf.pdf}
                                    title={selectedPdf.title}
                                    width="100%"
                                    height="600px"
                                    frameBorder="0"
                                    allowFullScreen
                                />
                            )}
                        </div>
                    )}
                </Modal.Body>
         <Modal.Footer className="d-flex justify-content-between">
    {selectedPdf?.image && selectedPdf?.pdf ? (
        <>
            <Form.Check 
                type="radio" 
                label="PDF" 
                name="mediaSelection"
                checked={openPdf} 
                onChange={() => {
                    setOpenPdf(true);
                    setOpenImage(false);
                }} 
            />
            <Form.Check 
                type="radio" 
                label="Image" 
                name="mediaSelection"
                checked={openImage} 
                onChange={() => {
                    setOpenImage(true);
                    setOpenPdf(false);
                }} 
            />
            <Button
                className="new-tab"
                variant="primary"
                onClick={() => {
                    if (openPdf) window.open(selectedPdf.pdf, "_blank");
                    if (openImage) window.open(selectedPdf.image, "_blank");
                    if (!openPdf && !openImage) alert("Please select at least one option.");
                }}
            >
                Open in New Tab
            </Button>
        </>
    ) : (
        <Button
            className="new-tab"
            variant="primary"
            onClick={() => {
                if (selectedPdf?.image) {
                    window.open(selectedPdf.image, "_blank");
                } else if (selectedPdf?.pdf) {
                    window.open(selectedPdf.pdf, "_blank");
                } else {
                    alert("No image or PDF available for this update.");
                }
            }}
        >
            Open in New Tab
        </Button>
    )}
    <Button variant="secondary" onClick={handleClosePdfModal}>
        Close
    </Button>
</Modal.Footer>
            </Modal>
        </>
    );
};

export default LatestUpdatesPage;